module.exports = __webpack_public_path__ + "img/banner_wrap1.4f6e7f7b.png";